import type { InjectionKey, Ref } from 'vue';

export const IAD_PARIS = [2.343714, 48.86524] satisfies LgnLat;
// Since it isn't a part of Design Tokens (yet)
// keep it here
export const MARKER_COLOR = `#E65719`;
export const CIRCLE_COLOR = `#00628C`;

export function getIsValidPosition(unsafePosition: UnsafeLgnLat) {
  if (!Array.isArray(unsafePosition)) return false;
  const position = unsafePosition.map(lngOrLat => typeof lngOrLat === `string` ? Number.parseFloat(lngOrLat) : lngOrLat);
  const isValid = position.every(lngOrLat => Number.isFinite(lngOrLat));
  return isValid;
}

export function getSafePosition(unsafePosition: UnsafeLgnLat) {
  if (!getIsValidPosition(unsafePosition)) return IAD_PARIS;
  const position = unsafePosition.map(lngOrLat => typeof lngOrLat === `string` ? Number.parseFloat(lngOrLat) : lngOrLat);
  return position as LgnLat; // didn't find a way to keep Tuple format
}

export function useSafePosition(unsafePosition: Ref<UnsafeLgnLat>) {
  const position = computed(() => getSafePosition(unsafePosition.value));

  return {
    position,
  };
}

// INTERACTIVE MAP PROVIDE/INJECT
export interface MapBoxInjected {
  mapbox: Ref<mapboxgl.Map | undefined>
};
export interface MapBoxLayerSpecificationInject {
  layerSpecification: Ref<mapboxgl.LayerSpecification | undefined>
}
export const MAPBOX_PROVIDE_INJECT = Symbol(`MAPBOX_PROVIDE_INJECT`) as InjectionKey<MapBoxInjected>;
export const MAPBOX_LAYER_SPECIFICATION_PROVIDE_INJECT = Symbol(`MAPBOX_LAYER_SPECIFICATION_PROVIDE_INJECT`) as InjectionKey<MapBoxLayerSpecificationInject>;

export type LgnLat = [longitude: number, latitude: number];
export type UnsafeLgnLat = [longitude: number | string | undefined, latitude: number | string | undefined];
